import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { toast } from "@ravenpay/raven-bank-ui";
import { InsightState } from "./types";
import { decrypt2 } from "../utils/encrypt";
import { log } from "node:console";
// import { ENCRYPTION_KEY_VAL } from "../utils/helpers";
// import { encrypt2 } from "../utils/encrypt";
// import { logger } from '../services/logger';
// import { TeamFormData } from '../pages/dashboard/settings/components/team';
// import { setCookie } from '../utils/helper/Helper';

interface LoginPayload {
  // Add appropriate types for the payload
  duration?: string;
}

interface singleTerminalPayload {
  // Add appropriate types for the payload
  serial?: string;
  perPage?: string | number;
  currentPage?: string | number;
  search?: string;
  start_date?: string;
  stop_date?: string;
  serial_no?: string;
  status?: string;
}

interface exportTerminalPayload {
  // Add appropriate types for the payload
  serial?: string;
  start_date?: string;
  stop_date?: string;
  serial_no?: string;
  exportType?: string;
}
interface exportVirtualTerminalPayload {
  start_date?: string;
  stop_date?: string;
}

interface receiptPayload {
  // Add appropriate types for the payload
  url?: string;
  endDate?: string;
  startDate?: string;
}

interface accountLookupPayload {
  bank_code: string;
  account_number: string;
}
interface changeSettlementPayload {
  account_number: string;
  bank_code:string;
  account_name: string;
  bank_name: string;

}
interface verifyRcNumberPayload {
  rcNumber: string;
}

interface creatStreamKeyPayload {
  // Add appropriate types for the payload
  account_number?: string;
  clear_keys?: boolean;
  use_key?: string;
  expire_at?: string;
  history_enabled: boolean;
}

interface toggleHistoryPayload {
  // Add appropriate types for the payload
  account_number?: string;
  history_enabled?: boolean;
}
interface requestTerminalPayload {
  quantity: number;
  delivery_state: string;
  delivery_address: string;
  delivery_lga: string;
  delivery_option: string; // or pickup
}
interface requestVirtualTerminalPayload {
  accountNumber: string;
  label: string;
  purpose: string;
}
interface getStreamkey {
  // Add appropriate types for the payload
  account_number?: string;
}

export const veryfyRcNumber = createAsyncThunk(
  "web/rcNumber",
  async (payload: verifyRcNumberPayload, thunkAPI) => {
    try {
      const { data } = await axios.get(
        `/merchant/pdon/cac/validate?rc_number=${payload?.rcNumber || ""}`
      );
      // console.log(data, "---------new-------");

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          // toast.error(data?.data);
        }
        // toast.error(data?.data, {
        //   position: "top-right",
        // });
        else return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        // console.log(data);

        thunkAPI.dispatch(SET_BUSINESS_DETAILS(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const getAllInsights = createAsyncThunk(
  "web/all-insights",
  async (payload: receiptPayload, thunkAPI) => {
    try {
      const { data } = await axios.get(
        `/merchant/pdon/get_insight?startDate=${
          payload?.startDate || ""
        }&stopDate=${payload?.endDate || ""}`
      );
      // console.log(data, "---------new-------");

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          // toast.error(data?.data);
        }
        // toast.error(data?.data, {
        //   position: "top-right",
        // });
        else return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        // console.log(data);

        thunkAPI.dispatch(SET_ALL_INSIGHT(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const downloadReceipt = createAsyncThunk(
  "web/download-receipt",
  async (payload: receiptPayload, thunkAPI) => {
    try {
      const { data } = await axios.get(`/download/${payload?.url}`);
      //   console.log(data);

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          toast.error(data?.data);
        } else
          toast.error(data?.data, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        //   thunkAPI.dispatch(SET_ALL_INSIGHT(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const getAllInsightTerminals = createAsyncThunk(
  "web/all-insight-terminals",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const { data } = await axios.get(
        `/merchant/pdon/get_terminals?page=1&per_page=5`
      );
      // console.log(data, "---------------hghj-------------------");

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          toast.error(data?.data);
        } else
          toast.error(data?.data, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        // console.log(data.data);

        thunkAPI.dispatch(SET_ALL_TERMINALS(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const getSingleInsightTerminals = createAsyncThunk(
  "web/single-insight-terminals",
  async (payload: singleTerminalPayload, thunkAPI) => {
    try {
      const { data } = await axios.get(
        `/merchant/pdon/get_terminal?serial=${payload?.serial || ""}`
      );
      console.log(data, "------------------");

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          toast.error(data?.data);
        } else
          toast.error(data?.data, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        // console.log(data);

        thunkAPI.dispatch(SET_SINGLE_TERMINALS(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);
export const getMerchantSettlementInfo = createAsyncThunk(
  "web/all-merchant-settlement-info",
  async (payload: any, thunkAPI) => {
    try {
      const { data } = await axios.get(`/merchant/pdon/getinfo`);
      // console.log(data);

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          //   toast.error(data?.data);
        } else
          toast.error(data?.data, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        thunkAPI.dispatch(SET_MERCHANT_SETTLEMENT_INFO(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const getMerchantTerminalRequest = createAsyncThunk(
  "web/all-merchant-terminal-request",
  async (payload: any, thunkAPI) => {
    try {
      const { data } = await axios.get(`/merchant/pdon/device_requests`);
      // console.log(data);

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          //   toast.error(data?.data);
        } else
          toast.error(data?.data, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        // console.log(data?.data?.data);

        thunkAPI.dispatch(SET_MERCHANT_DEVICE_REQUEST(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const getAllBanks = createAsyncThunk(
  "web/get-banks",
  async (payload: any, thunkAPI) => {
    try {
      const { data } = await axios.get(`/merchant/pdon/get_banks`);

      if (data?.status === "fail") {
        // thunkAPI.dispatch(SET_ALL_BANKS([]));
        return thunkAPI.rejectWithValue(data);
      }

      if (data?.status === "success") {
        thunkAPI.dispatch(SET_ALL_BANKS(data?.data?.data));

        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const accountLookUp = createAsyncThunk(
  `web/account-lookup`,
  async (payload: accountLookupPayload, thunkAPI) => {
    try {
      const { data } = await axios.post(
        `/merchant/pdon/account_number_lookup`,
        payload
      );

      if (data.status === "fail") {
        return thunkAPI.rejectWithValue(data);
      }
      if (data.status === "success") {
        return data;
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getSingleInsightTerminalTransactions = createAsyncThunk(
  "web/single-insight-terminals-transactions",
  async (payload: singleTerminalPayload, thunkAPI) => {
    try {
      const { data } = await axios.get(
        `/merchant/pdon/get_transactions?serial=${payload?.serial || ""}${
          payload?.currentPage ? `&page=${payload?.currentPage}` : ""
        }${payload?.perPage ? `&per_page=${payload?.perPage}` : ""}${
          payload?.search ? `&search=${payload?.search}` : ""
        }`
      );
      // console.log(data, "------------------");

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          toast.error(data?.data);
        } else
          toast.error(data?.data, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        //   console.log(data);

        thunkAPI.dispatch(SET_SINGLE_TERMINAL_TRX(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const getInsightTerminalTransactions = createAsyncThunk(
  "web/insight-terminals-transactions",
  async (payload: singleTerminalPayload, thunkAPI) => {
    // console.log(payload);

    try {
      const { data } = await axios.get(
        `/merchant/pdon/get_transactions?${
          payload?.currentPage ? `&page=${payload?.currentPage}` : ""
        }${payload?.perPage ? `&per_page=${payload?.perPage}` : ""}${
          payload?.search
            ? `&search=${payload?.search}${
                payload.start_date ? "&start_date=" + payload.start_date : ""
              }${payload.stop_date ? "&stop_date=" + payload.stop_date : ""}${
                payload.serial_no ? "&serial_no=" + payload.serial_no : ""
              }`
            : ""
        }`
      );
      // console.log(data, "------------------");

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          toast.error(data?.data);
        } else
          toast.error(data?.data, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        thunkAPI.dispatch(SET_ALL_TERMINALS_TRX(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const getSingleInsightTerminalTransactionsFilter = createAsyncThunk(
  "web/single-insight-terminals-transactions-filter",
  async (payload: singleTerminalPayload, thunkAPI) => {
    try {
      const { data } = await axios.get(
        `/merchant/pdon/get_transactions?serial=${payload?.serial || ""}${
          payload.start_date ? "&start_date=" + payload.start_date : ""
        }${payload.stop_date ? "&stop_date=" + payload.stop_date : ""}${
          payload.serial_no ? "&serial=" + payload.serial_no : ""
        }${payload.search ? "&search=" + payload.search : ""}`
      );
      // console.log(data, "------------------");

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          toast.error(data?.data);
        } else
          toast.error(data?.data, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        // console.log(data);

        thunkAPI.dispatch(SET_SINGLE_TERMINAL_TRX(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const getSingleInsightTerminalTransactionsExport = createAsyncThunk(
  "web/single-insight-terminals-transactions-export",
  async (payload: singleTerminalPayload, thunkAPI) => {
    try {
      const { data } = await axios.get(
        `/merchant/pdon/get_transactions?${
          payload.start_date ? "start_date=" + payload.start_date : ""
        }${payload.stop_date ? "&stop_date=" + payload.stop_date : ""}${
          payload.serial_no ? "&serial=" + payload.serial_no : ""
        }`
      );
      // console.log(data, "------------------");

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          toast.error(data?.data);
        } else
          toast.error(data?.data, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        //   console.log(data);

        // thunkAPI.dispatch(SET_SINGLE_TERMINAL_TRX(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const getInsightTerminalTransactionsFilter = createAsyncThunk(
  "web/insight-terminals-transactions-filter",
  async (payload: singleTerminalPayload, thunkAPI) => {
    // console.log(payload);

    try {
      const { data } = await axios.get(
        `/merchant/pdon/get_transactions?${
          payload.start_date ? "&start_date=" + payload.start_date : ""
        }${payload.stop_date ? "&stop_date=" + payload.stop_date : ""}${
          payload.serial_no ? "&serial=" + payload.serial_no : ""
        }${payload.search ? "&search=" + payload.search : ""}${
          payload.status ? "&status=" + payload.status : ""
        }`
      );
      // console.log(data, "------------------");

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          toast.error(data?.data);
        } else
          toast.error(data?.data, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        // console.log(data);

        thunkAPI.dispatch(SET_ALL_TERMINALS_TRX(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const exportTransaction = createAsyncThunk(
  "web/export-transaction",
  async (payload: exportTerminalPayload, thunkAPI) => {
    // console.log(payload);

    try {
      const { data } = await axios.get(
        `/merchant/pdon/export_transactions?${
          payload.exportType ? "file_type=" + payload.exportType : ""
        }${payload.start_date ? "start_date=" + payload.start_date : ""}${
          payload.stop_date ? "&stop_date=" + payload.stop_date : ""
        }${payload.serial_no ? "&serial_no=" + payload.serial_no : ""}${
          payload.serial_no ? "&serial=" + payload.serial_no : ""
        }`
      );
      //   console.log(data, "------------------");

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          toast.error(data?.data);
        } else
          toast.error(data?.data, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        // thunkAPI.dispatch(SET_ALL_TERMINALS_TRX(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);
export const virtualTerminalExport = createAsyncThunk(
  "web/export-virtual-terminal",
  async (payload: exportVirtualTerminalPayload, thunkAPI) => {
    // console.log(payload);

    try {
      const { data } = await axios.get(
        `/merchant/pdon/virtual_terminals/export`
        // ?${
        //   payload.start_date ? "start_date=" + payload.start_date : ""
        // }${payload.stop_date ? "&stop_date=" + payload.stop_date : ""}`
      );
      console.log(data, "------------------");

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          toast.error(data?.data);
        } else
          toast.error(data?.data, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        // thunkAPI.dispatch(SET_ALL_TERMINALS_TRX(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const createStreamKey = createAsyncThunk(
  "web/create_stream_key",
  async (payLoad: creatStreamKeyPayload, thunkAPI) => {
    try {
      // console.log("i am payload", payLoad);
      const { data } = await axios.post(
        "/merchant/pdon/stream/generate-key",
        payLoad
      );
      // console.log("API Response------:", data);
      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          toast.error(data?.data);
        } else
          toast.error(data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }

      // console.log(data.data.message);

      if (data?.status === "success") {
        toast.success(data?.data.message, {
          position: "top-right",
        });
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const changeSettlementDetails = createAsyncThunk(
  "web/change_settlement_details",
  async (payLoad: changeSettlementPayload, thunkAPI) => {
    try {
      // console.log("i am payload", payLoad);
      const { data } = await axios.post(
        "/merchant/pdon/settlement/change_details",
        payLoad
      );
      // console.log("API Response------:", data);
      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          toast.error(data?.data);
        } else
          toast.error(data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        toast.success(data?.data.message, {
          position: "top-right",
        });
        thunkAPI.dispatch(SET_SETTLEMENT_UPDATED_DETAILS(data?.data?.data));
        return data;
      }
        
       
      
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const requestTerminal = createAsyncThunk(
  "web/get-request-terminal",
  async (payload: requestTerminalPayload, thunkAPI) => {
    try {
      const { data } = await axios.post(
        `/merchant/pdon/request_device
        `,
        payload
      );

      if (data?.status === "fail") {
        toast.error(data?.data, {
          position: "top-right",
        });
      }
      if (data?.status === "success") {
        //  console.log(data?.data?.data, "-----------");

        toast.success(data?.data.message, {
          position: "top-right",
        });

        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const toggleStreamKeyHistory = createAsyncThunk(
  "web/toggle_stream_key",
  async (payLoad: toggleHistoryPayload, thunkAPI) => {
    try {
      const { data } = await axios.post(
        "/merchant/pdon/stream/set-history",
        payLoad
      );

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          toast.error(data?.data);
        } else
          toast.error(data?.data, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        toast.success(data?.data?.message, {
          position: "top-right",
        });
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const addAlertReceiverFunc = createAsyncThunk(
  "web/add-alert-reciever",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const { data } = await axios.post(
        "/merchant/pdon/add_alert_details",
        payload
      );
      //   console.log(data);/atlas/pdon/add_alert_details

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          toast.error(data?.data);
        } else
          toast.error(data?.data, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        toast.success(data?.data?.message, {
          position: "top-right",
        });
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const deleteAlertReceiverFunc = createAsyncThunk(
  "web/delete-alert-reciever",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const { data } = await axios.post(
        "/merchant/pdon/remove_alert_details",
        payload
      );
      //   console.log(data);/atlas/pdon/add_alert_details

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          toast.error(data?.data);
        } else
          toast.error(data?.data, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        toast.success(data?.data?.message, {
          position: "top-right",
        });
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const getAlertReceivers = createAsyncThunk(
  "web/get-alert-receiver",
  async (payload: any, thunkAPI) => {
    // console.log(payload);

    try {
      const { data } = await axios.get(
        `merchant/pdon/get_alert_details?tid=${payload?.id}`
      );
      // console.log(data, "------------------");

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          // toast.error(data?.data);
        }
        // toast.error(data?.data, {
        //   position: "top-right",
        // });
        else return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        // console.log(data);

        thunkAPI.dispatch(SET_ALL_ALERT_RECEIVERS(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        // toast.error(error.message, {
        //   position: "top-right",
        // });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);
export const deleteStreamKey = createAsyncThunk(
  "web/delete-stream-key",
  async (payload: any, thunkAPI) => {
    console.log("i am payload", payload);

    try {
      const { data } = await axios.post(`/merchant/pdon/stream/remove-account`);
      console.log(data, "------------------");

      if (data?.status === "fail") {
        toast.error(data?.data);

        return data;
      }

      if (data?.status === "success") {
        // console.log(data?.data?.data, "-----------");
        toast.success(data?.data?.message, {
          position: "top-right",
        });

        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        // toast.error(error.message, {
        //   position: "top-right",
        // });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const getStreamKey = createAsyncThunk(
  "web/get-stream-key",
  async (payload: any, thunkAPI) => {
    // console.log("i am payload",payload);

    try {
      const { data } = await axios.get(
        `/merchant/pdon/stream/get-key?account_number=${
          payload?.account_number || ""
        }`
      );
      // console.log(data, "------------------");

      if (data?.status === "fail") {
        thunkAPI.dispatch(SET_GET_STREAM_KEY({}));
        // toast.error(data?.data, {
        //   position: "top-right",
        // });
        return data;
        // else return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        // console.log(data?.data?.data, "-----------");

        thunkAPI.dispatch(SET_GET_STREAM_KEY(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        // toast.error(error.message, {
        //   position: "top-right",
        // });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const generateAccountNumber = createAsyncThunk(
  "web/generate-account-number",
  async (payload: any, thunkAPI) => {
    // console.log("i am payload",payload);

    try {
      const { data } = await axios.get(
        `/merchant/pdon/generate_account_number`
      );
      // console.log(data, "------------------");

      if (data?.status === "fail") {
        toast.error(data?.data, {
          position: "top-right",
        });
        return data;
        // else return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        // toast.error(error.message, {
        //   position: "top-right",
        // });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const getSingleRequestDetail = createAsyncThunk(
  "web/get-single-request-detail",
  async (payload: any, thunkAPI) => {
    //  console.log(payload);

    try {
      const { data } = await axios.get(
        `merchant/pdon/device_request/${payload?.id}`
      );
      console.log(data, "----------ddd--------");

      if (data?.status === "fail") {
        if (typeof data?.data === "string") {
          thunkAPI.dispatch(SET_SINGLE_TERMINAL_REQUEST({}));
        }
        // toast.error(data?.data, {
        //   position: "top-right",
        // });
        else return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        // console.log(data);
        thunkAPI.dispatch(SET_SINGLE_TERMINAL_REQUEST(data?.data?.data));
        return data.data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        // toast.error(error.message, {
        //   position: "top-right",
        // });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const getDeliveryLocations = createAsyncThunk(
  "web/get-delivery-locations",
  async (payload: any, thunkAPI) => {
    //  console.log("i am payload",payload);

    try {
      const { data } = await axios.get(
        `/merchant/pdon/delivery_locations
        `
      );

      if (data?.status === "fail") {
        thunkAPI.dispatch(SET_DISPATCH_LOCATIONS({}));
        // toast.error(data?.data, {
        //   position: "top-right",
        // });
        return data;
        // else return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        thunkAPI.dispatch(SET_DISPATCH_LOCATIONS(data?.data?.data));

        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        // toast.error(error.message, {
        //   position: "top-right",
        // });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);
export const getVirtualTerminals = createAsyncThunk(
  "web/get-virtual-terminals",
  async (payload: any, thunkAPI) => {
    //  console.log("i am payload",payload);

    try {
      const { data } = await axios.get(
        `/merchant/pdon/virtual_terminals?perPage=${payload?.per_page || 10}${
          payload?.status ? `&status=${payload?.status || ""}` : ""
        }${payload?.page ? `&page=${payload?.page || ""}` : ""}${
          payload?.start_date ? `&startDate=${payload?.start_date || ""}` : ""
        }
        `
      );

      if (data?.status === "fail") {
        return data;
        // else return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        thunkAPI.dispatch(SET_VIRTUAL_TERMINALS(data?.data?.data));

        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        // toast.error(error.message, {
        //   position: "top-right",
        // });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const getLocalGovernmentAreas = createAsyncThunk(
  "web/get-local-govt-areas",
  async (payload: any, thunkAPI) => {
    // console.log("i am payload",payload);

    try {
      const { data } = await axios.get(
        `/merchant/pdon/lgas?region=${payload?.name || ""}
        `
      );

      if (data?.status === "fail") {
        thunkAPI.dispatch(SET_LGA({}));
        // toast.error(data?.data, {
        //   position: "top-right",
        // });
        return data;
        // else return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        // console.log(data?.data?.data, "-----------");

        thunkAPI.dispatch(SET_LGA(data?.data?.data));

        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        // toast.error(error.message, {
        //   position: "top-right",
        // });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const searchVirtualTerminal = createAsyncThunk(
  "web/search-virtual-terminal",
  async (payload: { search: string }, thunkAPI) => {
    try {
      const { data } = await axios.get(
        `/merchant/pdon/virtual_terminals/search?search=${payload.search}`
      );

      if (data?.status === "fail") {
        thunkAPI.dispatch(SET_SEARCH_DATA({}));
        return data;
      }

      if (data?.status === "success") {
        thunkAPI.dispatch(SET_VIRTUAL_TERMINALS(data?.data?.data));
        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        // toast.error(error.message);
      }

      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

export const getRegions = createAsyncThunk(
  "web/get-regions",
  async (payload: any, thunkAPI) => {
    // console.log("i am payload",payload);

    try {
      const { data } = await axios.get(
        `/merchant/pdon/regions
        `
      );

      if (data?.status === "fail") {
        thunkAPI.dispatch(SET_REGIONS({}));
        // toast.error(data?.data, {
        //   position: "top-right",
        // });
        return data;
        // else return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        // console.log(data?.data?.data, "-----------");

        thunkAPI.dispatch(SET_REGIONS(data?.data?.data));

        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        // toast.error(error.message, {
        //   position: "top-right",
        // });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);
export const getBusinessInfo = createAsyncThunk(
  "web/business-info",
  async (payload: any, thunkAPI) => {
    // console.log("i am payload",payload);

    try {
      const { data } = await axios.get(`/merchant/pdon/business_info`);

      if (data?.status === "fail") {
        thunkAPI.dispatch(SET_BUSINESS_INFO({}));
        // toast.error(data?.data, {
        //   position: "top-right",
        // });
        return data;
        // else return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === "success") {
        thunkAPI.dispatch(SET_BUSINESS_INFO(data?.data?.data));

        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        // toast.error(error.message, {
        //   position: "top-right",
        // });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);
export const requestVirtualTerminal = createAsyncThunk(
  "web/get-request-virtual-terminal",
  async (payload: requestVirtualTerminalPayload, thunkAPI) => {
    //  console.log("i am payload",payload);

    try {
      const { data } = await axios.post(
        `/merchant/pdon/create_virtual_terminal
        `,
        payload
      );

      if (data?.status === "fail") {
        toast.error(data?.data, {
          position: "top-right",
        });
      }
      if (data?.status === "success") {
        // console.log(data?.data?.data, "-----------");

        toast.success(data?.data.message, {
          position: "top-right",
        });

        return data;
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);
const initialState: InsightState = {
  loading: false,
  loading_trx: false,
  loading_alert: false,
  loading_reciept: false,
  loading_rc: false,
  loading_vir: false,
  insights: {},
  insight_terminals: {},
  insight_terminal: {},
  insight_terminal_trx: {},
  insight_all_terminal_trx: {},
  alert_receivers: [],
  stream_key_info: {},
  get_stream_key: {},
  toggle_stream_history: {},
  settlement_details: {},
  all_banks: [],
  pickup_locations: [],
  local_governmen_areas: [],
  regions: [],
  all_device_request: {},
  all_virtual_terminals: {},
  single_terminal_request: {},
  loading_request: false,
  search_data: [],
  business_info: {},
  settlement_updated_details:{}
  // initialize other state properties
};

export const insightSlice = createSlice({
  name: "insight",
  initialState,

  reducers: {
    SET_ALL_INSIGHT: (state, action) => {
      state.insights = action.payload;
    },
    SET_ALL_TERMINALS: (state, action) => {
      state.insight_terminals = action.payload;
    },
    SET_ALL_ALERT_RECEIVERS: (state, action) => {
      state.alert_receivers = action.payload;
    },
    // SET_CREATE_STREAM_KEYS: (state, action) => {
    //   state.stream_key_info = action.payload;
    // },
    SET_GET_STREAM_KEY: (state, action) => {
      state.stream_key_info = action.payload;
    },
    TOGGLE_STREAM_HISTORY: (state, action) => {
      state.toggle_stream_history = action.payload;
    },
    SET_SINGLE_TERMINALS: (state, action) => {
      state.insight_terminal = action.payload;
    },
    SET_SINGLE_TERMINAL_TRX: (state, action) => {
      state.insight_terminal_trx = action.payload;
    },
    SET_ALL_TERMINALS_TRX: (state, action) => {
      state.insight_all_terminal_trx = action.payload;
    },
    SET_BUSINESS_DETAILS: (state, action) => {
      state.business_details = action.payload;
    },
    SET_MERCHANT_SETTLEMENT_INFO: (state, action) => {
      state.settlement_details = action.payload;
    },
    SET_ALL_BANKS: (state, action) => {
      state.all_banks = action.payload;
    },
    SET_DISPATCH_LOCATIONS: (state, action) => {
      state.pickup_locations = action.payload;
    },
    SET_LGA: (state, action) => {
      state.local_governmen_areas = action.payload;
    },
    SET_REGIONS: (state, action) => {
      state.regions = action.payload;
    },
    SET_MERCHANT_DEVICE_REQUEST: (state, action) => {
      state.all_device_request = action.payload;
    },
    SET_VIRTUAL_TERMINALS: (state, action) => {
      state.all_virtual_terminals = action.payload;
    },
    SET_SINGLE_TERMINAL_REQUEST: (state, action) => {
      state.single_terminal_request = action.payload;
    },
    SET_SEARCH_DATA: (state, action) => {
      state.search_data = action.payload;
    },
    SET_BUSINESS_INFO: (state, action) => {
      state.business_info = action.payload;
    },
    SET_SETTLEMENT_UPDATED_DETAILS: (state, action) => {
      state.settlement_updated_details = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getAlertReceivers.pending, (state) => {
      state.loading_alert = true;
    });
    builder.addCase(getAlertReceivers.fulfilled, (state) => {
      state.loading_alert = false;
    });
    builder.addCase(getAlertReceivers.rejected, (state) => {
      state.loading_alert = false;
    });
    builder.addCase(changeSettlementDetails.pending, (state) => {
      state.loading_alert = true;
    });
    builder.addCase(changeSettlementDetails.fulfilled, (state) => {
      state.loading_alert = false;
    });
    builder.addCase(changeSettlementDetails.rejected, (state) => {
      state.loading_alert = false;
    });
    builder.addCase(deleteAlertReceiverFunc.pending, (state) => {
      state.loading_reciept = true;
    });
    builder.addCase(deleteAlertReceiverFunc.fulfilled, (state) => {
      state.loading_reciept = false;
    });
    builder.addCase(deleteAlertReceiverFunc.rejected, (state) => {
      state.loading_reciept = false;
    });
    builder.addCase(downloadReceipt.pending, (state) => {
      state.loading_reciept = true;
    });
    builder.addCase(downloadReceipt.fulfilled, (state) => {
      state.loading_reciept = false;
    });
    builder.addCase(downloadReceipt.rejected, (state) => {
      state.loading_reciept = false;
    });
    builder.addCase(addAlertReceiverFunc.pending, (state) => {
      state.loading_reciept = true;
    });
    builder.addCase(addAlertReceiverFunc.fulfilled, (state) => {
      state.loading_reciept = false;
    });
    builder.addCase(addAlertReceiverFunc.rejected, (state) => {
      state.loading_reciept = false;
    });
    builder.addCase(createStreamKey.pending, (state) => {
      state.loading_alert = true;
    });
    builder.addCase(createStreamKey.fulfilled, (state) => {
      state.loading_alert = false;
    });
    builder.addCase(createStreamKey.rejected, (state) => {
      state.loading_alert = false;
    });

    builder.addCase(getBusinessInfo.pending, (state) => {
      state.loading_alert = true;
    });
    builder.addCase(getBusinessInfo.fulfilled, (state) => {
      state.loading_alert = false;
    });
    builder.addCase(getBusinessInfo.rejected, (state) => {
      state.loading_alert = false;
    });

    builder.addCase(searchVirtualTerminal.pending, (state) => {
      state.loading_vir = true;
    });
    builder.addCase(searchVirtualTerminal.fulfilled, (state) => {
      state.loading_vir = false;
    });
    builder.addCase(searchVirtualTerminal.rejected, (state) => {
      state.loading_vir = false;
    });

    builder.addCase(getStreamKey.pending, (state) => {
      state.loading_reciept = true;
    });
    builder.addCase(getStreamKey.fulfilled, (state) => {
      state.loading_reciept = false;
    });
    builder.addCase(getStreamKey.rejected, (state) => {
      state.loading_reciept = false;
    });
    builder.addCase(getSingleRequestDetail.pending, (state) => {
      state.loading_request = true;
    });
    builder.addCase(getSingleRequestDetail.fulfilled, (state) => {
      state.loading_request = false;
    });
    builder.addCase(getSingleRequestDetail.rejected, (state) => {
      state.loading_request = false;
    });
    builder.addCase(getMerchantTerminalRequest.pending, (state) => {
      state.loading_reciept = true;
    });
    builder.addCase(getMerchantTerminalRequest.fulfilled, (state) => {
      state.loading_reciept = false;
    });
    builder.addCase(getMerchantTerminalRequest.rejected, (state) => {
      state.loading_reciept = false;
    });

    builder.addCase(generateAccountNumber.pending, (state) => {
      state.loading_reciept = true;
    });
    builder.addCase(generateAccountNumber.fulfilled, (state) => {
      state.loading_reciept = false;
    });
    builder.addCase(generateAccountNumber.rejected, (state) => {
      state.loading_reciept = false;
    });

    builder.addCase(veryfyRcNumber.pending, (state) => {
      state.loading_rc = true;
    });
    builder.addCase(veryfyRcNumber.fulfilled, (state) => {
      state.loading_rc = false;
    });
    builder.addCase(veryfyRcNumber.rejected, (state) => {
      state.loading_rc = false;
    });
    builder.addCase(getDeliveryLocations.pending, (state) => {
      state.loading_reciept = true;
    });
    builder.addCase(getDeliveryLocations.fulfilled, (state) => {
      state.loading_reciept = false;
    });
    builder.addCase(getDeliveryLocations.rejected, (state) => {
      state.loading_reciept = false;
    });

    builder.addCase(getLocalGovernmentAreas.pending, (state) => {
      state.loading_reciept = true;
    });
    builder.addCase(getLocalGovernmentAreas.fulfilled, (state) => {
      state.loading_reciept = false;
    });
    builder.addCase(getLocalGovernmentAreas.rejected, (state) => {
      state.loading_reciept = false;
    });

    builder.addCase(toggleStreamKeyHistory.pending, (state) => {
      state.loading_reciept = true;
    });
    builder.addCase(toggleStreamKeyHistory.fulfilled, (state) => {
      state.loading_reciept = false;
    });
    builder.addCase(toggleStreamKeyHistory.rejected, (state) => {
      state.loading_reciept = false;
    });

    builder.addCase(getMerchantSettlementInfo.pending, (state) => {
      state.loading_reciept = true;
    });
    builder.addCase(getMerchantSettlementInfo.fulfilled, (state) => {
      state.loading_reciept = false;
    });
    builder.addCase(getMerchantSettlementInfo.rejected, (state) => {
      state.loading_reciept = false;
    });

    builder.addCase(getAllBanks.pending, (state) => {
      state.loading_reciept = true;
    });
    builder.addCase(getAllBanks.fulfilled, (state) => {
      state.loading_reciept = false;
    });
    builder.addCase(getAllBanks.rejected, (state) => {
      state.loading_reciept = false;
    });

    builder.addCase(getAllInsights.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllInsights.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getAllInsights.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getVirtualTerminals.pending, (state) => {
      state.loading_vir = true;
    });
    builder.addCase(getVirtualTerminals.fulfilled, (state) => {
      state.loading_vir = false;
    });
    builder.addCase(getVirtualTerminals.rejected, (state) => {
      state.loading_vir = false;
    });

    builder.addCase(requestTerminal.pending, (state) => {
      state.loading_vir = true;
    });
    builder.addCase(requestTerminal.fulfilled, (state) => {
      state.loading_vir = false;
    });
    builder.addCase(requestTerminal.rejected, (state) => {
      state.loading_vir = false;
    });

    builder.addCase(requestVirtualTerminal.pending, (state) => {
      state.loading_vir = true;
    });
    builder.addCase(requestVirtualTerminal.fulfilled, (state) => {
      state.loading_vir = false;
    });
    builder.addCase(requestVirtualTerminal.rejected, (state) => {
      state.loading_vir = false;
    });

    builder.addCase(getAllInsightTerminals.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllInsightTerminals.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getAllInsightTerminals.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getSingleInsightTerminals.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleInsightTerminals.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getSingleInsightTerminals.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(
      getSingleInsightTerminalTransactionsFilter.pending,
      (state) => {
        state.loading = true;
      }
    );
    builder.addCase(
      getSingleInsightTerminalTransactionsFilter.fulfilled,
      (state) => {
        state.loading = false;
      }
    );
    builder.addCase(
      getSingleInsightTerminalTransactionsFilter.rejected,
      (state) => {
        state.loading = false;
      }
    );
    builder.addCase(getInsightTerminalTransactionsFilter.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getInsightTerminalTransactionsFilter.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getInsightTerminalTransactionsFilter.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getInsightTerminalTransactions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getInsightTerminalTransactions.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getInsightTerminalTransactions.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getSingleInsightTerminalTransactions.pending, (state) => {
      state.loading_trx = true;
    });
    builder.addCase(getSingleInsightTerminalTransactions.fulfilled, (state) => {
      state.loading_trx = false;
    });
    builder.addCase(getSingleInsightTerminalTransactions.rejected, (state) => {
      state.loading_trx = false;
    });
    builder.addCase(accountLookUp.pending, (state) => {
      state.loading_trx = true;
    });
    builder.addCase(accountLookUp.fulfilled, (state) => {
      state.loading_trx = false;
    });
    builder.addCase(accountLookUp.rejected, (state) => {
      state.loading_trx = false;
    });
  },
});

// Action creators are generated for each case reducer function
export const {
  SET_SINGLE_TERMINAL_TRX,
  SET_ALL_INSIGHT,
  SET_ALL_TERMINALS,
  SET_SINGLE_TERMINALS,
  SET_ALL_TERMINALS_TRX,
  SET_ALL_ALERT_RECEIVERS,
  // SET_CREATE_STREAM_KEYS,
  SET_GET_STREAM_KEY,
  SET_BUSINESS_DETAILS,
  SET_MERCHANT_SETTLEMENT_INFO,
  SET_ALL_BANKS,
  SET_DISPATCH_LOCATIONS,
  SET_LGA,
  SET_REGIONS,
  SET_MERCHANT_DEVICE_REQUEST,
  SET_VIRTUAL_TERMINALS,
  SET_SINGLE_TERMINAL_REQUEST,
  SET_SEARCH_DATA,
  SET_BUSINESS_INFO,
  SET_SETTLEMENT_UPDATED_DETAILS,
} = insightSlice.actions;

export default insightSlice.reducer;
